import { VariantClassesProps } from '../../utils'
import { SnackBarVariant } from './SnackBar.types'

export const getSnackBarRootClasses = () => {
    return 'min-h-[48px] px-[16px] py-[12px] rounded-md flex flex-row items-center'
}

export const getRootColor = (variant: SnackBarVariant) => {
    const colors: VariantClassesProps = {
        success: 'bg-green-400/80',
        error: 'bg-red-500/80',
        info: 'bg-[hsl(var(--background-tooltip))]/80',
        warning: 'bg-yellow-400/80',
    }
    return colors[variant]
}

export const getMessageColor = (variant: SnackBarVariant) => {
    const colors: VariantClassesProps = {
        success: 'text-title',
        error: 'text-title',
        info: 'text-title',
        warning: 'text-title',
    }
    return colors[variant]
}

export const getMessageClasses = () => {
    return 'font-sans font-bold leading-tight flex flex-row justify-center items-center'
}
